import { Text } from '@thefarmersfront/kitchen';

import { Link } from '~/components/common';

import { toSafeString } from '~/utils';

import styles from './TextWithLinkCell.module.scss';

const TextWithLinkCell = ({ value }: { value?: string | null }) => {
  const text = toSafeString(value);

  const urlRegex = /(https?:\/\/[^\s)]+)/g;

  const textParts = text.split(urlRegex);

  const textElements = textParts.map((part, index) => {
    const elementKey = `${index}-${part}`;

    if (urlRegex.test(part)) {
      return <Link key={elementKey} text={part} href={part} target="_blank" />;
    } else {
      return (
        <Text key={elementKey} size="large" element="span">
          {part}
        </Text>
      );
    }
  });

  return <div className={styles['cell-container']}>{textElements}</div>;
};

export default TextWithLinkCell;
